// MUI
import { Stack } from "@mui/material";

// Images
import RTCLogo from "@/assets/images/commons/dat_logo_rtc.svg";
import { Link } from "react-router-dom";

const LoginHeader = () => {
	return (
		<Link to="/">
			<Stack justifyContent="center" alignItems="center" className="mt-[62.48px] mb-[46.5px] h-[58.91px] w-[513px] px-[14px]">
				<img src={RTCLogo} className="" alt="Login logo" />
			</Stack>
		</Link>
	);
};

export default LoginHeader;
